import { render, staticRenderFns } from "./BankAccountsView.vue?vue&type=template&id=7a896c86&"
import script from "./BankAccountsView.vue?vue&type=script&lang=ts&"
export * from "./BankAccountsView.vue?vue&type=script&lang=ts&"
import style0 from "./BankAccountsView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports